import { render, staticRenderFns } from "./onlineQuizzes.vue?vue&type=template&id=8a5381da&scoped=true"
import script from "./onlineQuizzes.vue?vue&type=script&lang=js"
export * from "./onlineQuizzes.vue?vue&type=script&lang=js"
import style0 from "./onlineQuizzes.vue?vue&type=style&index=0&id=8a5381da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5381da",
  null
  
)

export default component.exports